import React from 'react';
import { Table as PfTable } from 'patternfly-react';

export default value => <PfTable.Cell>{value}</PfTable.Cell>;



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/common/table/formatters/cellFormatter.js